import { CommunicationItem } from "@/components/widgets/Communication";
import { contactsConfig } from "@/config/contacts.config";
import GmailIcon from "@/icons/communication/gmail.svg";
import PhoneIcon from "@/icons/communication/phone.svg";
import TelegramIcon from "@/icons/communication/telegram.svg";
import ViberIcon from "@/icons/communication/viber.svg";
import WeChatIcon from "@/icons/communication/we-chat.svg";
import WhatsappIcon from "@/icons/communication/whatsapp.svg";

import PhonePandaIcon from "@/icons/panda/call.svg";
import WhatsappPandaIcon from "@/icons/panda/whatsapp.svg";
import TelegramPandaIcon from "@/icons/panda/telegram.svg";
import ViberPandaIcon from "@/icons/panda/viber.svg";
import TelegramBotPandaIcon from "@/icons/panda/telegrambot.svg";

// Write configuration
export const writeConfig = [
  contactsConfig.whatsapp && {
    value: "whatsapp",
    label: "Whatsapp",
    icon: WhatsappIcon,
    link: contactsConfig.whatsapp,
    id: "send-wa",
  },
  contactsConfig.viber && {
    value: "viber",
    label: "Viber",
    icon: ViberIcon,
    link: contactsConfig.viber,
    id: "send-viber",
  },
  contactsConfig.email && {
    value: "gmail",
    label: "Gmail",
    icon: GmailIcon,
    link: "mailto:" + contactsConfig.email,
    id: "send-gmail",
  },
  contactsConfig.telegram && {
    value: "telegram",
    label: "Telegram",
    icon: TelegramIcon,
    link: contactsConfig.telegram,
    id: "send-telegram",
  },
  contactsConfig.wechat && {
    value: "we-chat",
    label: "WeChat",
    icon: WeChatIcon,
    link: contactsConfig.wechat,
    id: "send-wechat",
  },
].filter(Boolean) as CommunicationItem[];

// Default call configuration (from call.config.ts)
export const callConfig = [
  contactsConfig.phone && {
    value: "phone",
    label: "Phone",
    icon: PhoneIcon,
    link: "tel:" + contactsConfig.phone,
    id: "call-phone",
  },
  contactsConfig.whatsapp && {
    value: "whatsapp-call",
    label: "Whatsapp",
    icon: WhatsappIcon,
    link: contactsConfig.whatsapp,
    id: "call-wa",
  },
  contactsConfig.viber && {
    value: "viber-call",
    label: "Viber",
    icon: ViberIcon,
    link: contactsConfig.viber,
    id: "call-viber",
  },
  contactsConfig.telegram && {
    value: "telegram-call",
    label: "Telegram",
    icon: TelegramIcon,
    link: contactsConfig.telegram,
    id: "call-telegram",
  },
  contactsConfig.wechat && {
    value: "we-chat-call",
    label: "WeChat",
    icon: WeChatIcon,
    link: contactsConfig.wechat,
    id: "call-wechat",
  },
].filter(Boolean) as CommunicationItem[];

// Combined communication configuration
export const communicationConfig = [
  contactsConfig.phone && {
    value: "phone",
    label: "Phone",
    icon: PhoneIcon,
    link: "tel:" + contactsConfig.phone,
    id: "comm-phone",
  },
  contactsConfig.whatsapp && {
    value: "whatsapp",
    label: "Whatsapp",
    icon: WhatsappIcon,
    link: contactsConfig.whatsapp,
    id: "comm-wa",
  },
  contactsConfig.viber && {
    value: "viber",
    label: "Viber",
    icon: ViberIcon,
    link: contactsConfig.viber,
    id: "comm-viber",
  },
  contactsConfig.email && {
    value: "gmail",
    label: "Gmail",
    icon: GmailIcon,
    link: "mailto:" + contactsConfig.email,
    id: "comm-gmail",
  },
  contactsConfig.telegram && {
    value: "telegram",
    label: "Telegram",
    icon: TelegramIcon,
    link: contactsConfig.telegram,
    id: "comm-telegram",
  },
  contactsConfig.wechat && {
    value: "we-chat",
    label: "WeChat",
    icon: WeChatIcon,
    link: contactsConfig.wechat,
    id: "comm-wechat",
  },
].filter(Boolean) as CommunicationItem[];

export const pandaCallBackConfig = [
  contactsConfig.phone && {
    value: "call",
    label: "Call",
    icon: PhonePandaIcon,
    link: "tel:" + contactsConfig.phone,
    id: "call-widget",
  },
  contactsConfig.whatsapp && {
    value: "whatsapp",
    label: "Whatsapp",
    icon: WhatsappPandaIcon,
    link: contactsConfig.whatsapp,
    id: "write-wa",
  },
  contactsConfig.telegram && {
    value: "telegram",
    label: "Telegram",
    icon: TelegramPandaIcon,
    link: contactsConfig.telegram,
    id: "write-telegram",
  },
  contactsConfig.viber && {
    value: "viber",
    label: "Viber",
    icon: ViberPandaIcon,
    link: contactsConfig.viber,
    id: "write-viber",
  },
  contactsConfig.telegramBot && {
    value: "telegram-bot",
    label: "Telegram bot",
    icon: TelegramBotPandaIcon,
    link: contactsConfig.telegramBot,
    id: "write-telegrambot",
  },
].filter(Boolean) as CommunicationItem[];
